<template>
  <div class="CheckoutPayment">
  <div class="container" id="containergeneral">
  <div class="row">
    <div class="col-75">
      <div class="containercard">
        <form @submit.prevent="createToken()">

          <div class="row">
            <div class="col-50">
              <h3>Dirección de Envío</h3>
              <br>
              <label for="fname"><i class="fa fa-user"></i> Nombre Completo</label>
              <input type="text" id="fname" name="firstname" placeholder="John M. Doe">

              <label for="email"><i class="fa fa-envelope"></i> Email</label>
              <input type="text" id="card[email]" data-culqi="card[email]" name="email" placeholder="john@example.com">

              <label for="adr"><i class="fa fa-address-card-o"></i> Dirección</label>
              <input type="text" id="adr" name="address" placeholder="542 W. 15th Street">

              <label for="city"><i class="fa fa-institution"></i> Ciudad</label>
              <input type="text" id="city" name="city" placeholder="New York">

              <div class="row">
                <div class="col-50">
                  <label for="state">State</label>
                  <input type="text" id="state" name="state" placeholder="NY">
                </div>
                <div class="col-50">
                  <label for="zip">Zip</label>
                  <input type="text" id="zip" name="zip" placeholder="10001">
                </div>
              </div>
            </div>

            <div class="col-50">
              <h3>Información de Pago</h3>
              <br>
              <label for="fname">Tarjetas Aceptadas</label>
              <div class="icon-container">
                <i class="fa fa-cc-visa" style="color:navy;"></i>&nbsp;
                <i class="fa fa-cc-amex" style="color:blue;"></i>&nbsp;
                <i class="fa fa-cc-mastercard" style="color:red;"></i>&nbsp;
                <i class="fa fa-cc-discover" style="color:orange;"></i>
              </div>

              <label for="cname">Nombre de Tarjeta</label>
              <input type="text" id="cname" name="cardname" placeholder="John More Doe">

              <label for="ccnum">Número de Tarjeta</label>
              <input type="text" id="card[number]" data-culqi="card[number]" name="cardnumber" placeholder="1111-2222-3333-4444">

              <div class="row">
                <div class="col-25">
                  <label for="expmonth">Exp Month</label>
                  <input type="text" id="card[exp_month]" data-culqi="card[exp_month]" name="expyear" placeholder="2020">
                </div>
                <div class="col-50">
                  <label for="cvv">Exp Year</label>
                  <input type="text" id="card[exp_year]" data-culqi="card[exp_year]" placeholder="2020">
                </div>
              </div>
              <label for="cvv">CVV</label>
              <input type="text" size="3" id="card[cvv]" data-culqi="card[cvv]" name="cvv" placeholder="123">
            </div>
          </div>

          <label>
          <input type="checkbox" checked="checked" name="sameadr"> Shipping address same as billing
          </label>
          <input type="submit" value="Pagar" class="btncard">
        </form>
      </div>
    </div>

    <div class="col-25">
      <div class="containercard">
        <h4>Cart 
          <span class="price" style="color:black">
            <i class="fa fa-shopping-cart"></i> 
            <b> 4</b>
          </span>
        </h4>
        <p><a href="#">Product 1</a> <span class="price">$15</span></p>
        <p><a href="#">Product 2</a> <span class="price">$5</span></p>
        <p><a href="#">Product 3</a> <span class="price">$8</span></p>
        <p><a href="#">Product 4</a> <span class="price">$2</span></p>
        <hr>
        <p>Total <span class="price" style="color:black"><b>$30</b></span></p>
      </div>
    </div>
  </div>
  </div>
  </div>
</template>

<script>
  Culqi.publicKey = 'pk_test_cZJm1j7hvWp5lmPt';
  Culqi.init();
</script>

<style lang="scss" src="./CheckoutPayment.scss"></style>
